import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import {
    translateStateMachine,
    ComponentContextService, CustomControlSchema, DataFormBase, FormSchemaBase, StateMachinesService, TextControlSchema, UpperCorrector, StateMachinesDesignerComponent
} from 'tnx-shared';


@Component({
    selector: 'statemachines-form',
    templateUrl: './statemachines-form.component.html',
    styleUrls: ['./statemachines-form.component.scss'],
    providers: [ComponentContextService],
})
export class StateMachinesFormComponent extends DataFormBase implements OnInit {
    @ViewChild(StateMachinesDesignerComponent, { static: false }) designer: StateMachinesDesignerComponent;
    machinesData: any = { machines: [], connections: [] };
    constructor(
        protected _injector: Injector,
        private _stateMachinesService: StateMachinesService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._stateMachinesService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                label: 'Mã quy trình',
                fullLabel: 'Mã quy trình',
                field: 'code',
                correctors: [new UpperCorrector()],
                disabled: this.model.data.id != null
            }),
            new TextControlSchema({
                label: 'Tên quy trình',
                fullLabel: 'Tên quy trình',
                field: 'title',
            }),
            new CustomControlSchema({
                field: 'designer',
                label: this._translateService.instant('Thiết kế quy trình'),
                mdWidth: 12
            })
        ];
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
        const machinesData = JSON.parse(data.data);
        this.machinesData = {
            ...machinesData,
            ten: machinesData.title
        };
    }

    onBeforeSave() {
        // trước khi lưu
        this.model.data.data = JSON.stringify(this.designer.getDesignData());
    }
}

